import React, {useEffect} from "react";
import "./RecoveryPassword.sass";
import Window from "../../../../_containers/window/Window";
import {Navigate, useNavigate, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {MAIN} from "../../../../common/links";
import {acceptRecoveryPassword} from "../../../../_actions/auth/authService";
import {FAILED, LOADING} from "../../../../common/statuses";
import Spinner from "../Spinner";


export const RecoveryPassword = () => {

    const {recovery} = useSelector(state => state.auth);

    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (_.isEmpty(params.id) || _.isEmpty(params.uuid)) {
            navigate(MAIN);
        }
        if (!recovery) {
            const body = {
                id: params.id,
                uuid: params.uuid
            }
            dispatch(acceptRecoveryPassword(body))
        }
    }, [])
    useEffect(() => {
        if (recovery && recovery.status === FAILED) {
            navigate(MAIN);
        }
    }, [recovery])

    if (!recovery || recovery.status === LOADING) {
        return <Spinner/>
    }

    if (recovery.status === FAILED) {
        console.log("fail")
        return <Navigate to={MAIN}/>
    }

    return <Window>
        <div className="RecoveryPassword-title">{recovery.response.title}</div>
        <div className="RecoveryPassword-message">{recovery.response.message}</div>
    </Window>
}